import moment from 'moment';
import store from '@/store/store';

export const validGUID = (value) => {
  const regex = /[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i;
  const match = regex.exec(value);
  return match != null;
};

export const generateGuid = (noDashes = false) => {
  const S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  if (noDashes) {
    return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
  }
  return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
};

export const validEnum = (value, array) => array.includes(value);

export const generateButton = (name = 'default', { color = 'primary', appendClass = '' } = {}) => {
  let button = document.createElement('button');
  button.className = `px-3 helper-button vs-component vs-button vs-button-${color} vs-button-border ${appendClass}`;
  button.style.background = 'transparent';
  button.setAttribute('name', 'button');
  button.innerHTML = `
    <span class="vs-button-backgroundx vs-button--background" style="opacity: 0; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span>
    <span class="vs-button-text vs-button--text">${name}</span>
    <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
  `;

  return button;
};

export const generateLink = (
  name = 'default',
  { color = 'primary', appendClass = '', url = 'javascript:void(0)', blank = true } = {}
) => {
  let a = document.createElement('a');
  a.setAttribute('href', url);
  if (blank) {
    a.setAttribute('data-href', url);
    a.setAttribute('target', '_blank');
  }
  a.innerHTML = name;
  a.className = `text-${color} underline ${appendClass}`;

  return a;
};

export const generateChip = (name = 'default', { color = 'primary', appendClass = '' } = {}) => {
  let div = document.createElement('div');
  div.className = `con-vs-chip vs-chip-${color} custom-chip con-color ${appendClass}`;
  div.innerHTML = `<span class="text-chip vs-chip--text">${name}</span>`;

  return div;
};

export const deepCopy = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};

export const removePriceFormatting = (p) => {
  return parseFloat(p === 0 ? 0 : p.replace('$', '').replace(',', '')).toFixed(2);
};

export const formatPrice = (p, currency = '') => {
  if (!p && typeof p !== 'number') return '';
  if (currency === 'AUD') {
    currency = 'A$';
  } else if (currency === 'USD') {
    currency = 'US$';
  } else if (currency === 'GBP') {
    currency = '£';
  } else if (currency === 'EUR') {
    currency = '€';
  } else if (currency === 'CNY') {
    currency = '¥';
  }

  return (
    currency +
    parseFloat(p).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  );
};

export const getRangeOfDates = (start, end, key, arr = [start.startOf(key)]) => {
  if (start.isAfter(end)) throw new Error('start must precede end');
  const next = moment(start).add(1, key).startOf(key);
  if (next.isAfter(end, key)) return arr;
  return getRangeOfDates(next, end, key, [...arr, ...next]);
};

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const forceDownload = (file, name) => {
  let a = document.createElement('a');
  let urlObj = window.URL.createObjectURL(file);
  a.href = urlObj;
  a.download = name;
  document.body.append(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(urlObj);
};

export const showErrorNotification = (
  error,
  { throwError = false, customMessage = '', showNotification = true } = {}
) => {
  if (showNotification && (error.response.data.message || customMessage)) {
    app.$vs.notify({
      title: 'error',
      text: customMessage ? customMessage : error.response.data.message,
      color: 'danger',
      time: 4500
    });
    console.error(customMessage ? customMessage : error.response.data.message);
  }

  if (process.env.NODE_ENV !== 'production' && throwError) {
    throw error;
  }
};

export const toUTCDate = (date) => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
};

export const mapVuexToComputed = (moduleName, mutationName, arrayKeyValue) => {
  const functions = [];
  for (const [key, value] of Object.entries(arrayKeyValue)) {
    functions[key] = {
      get() {
        return value.split('.').reduce((a, b) => {
          return a[b];
        }, store.state[moduleName]);
      },
      set(v) {
        let payload = {};
        payload[key] = v;
        store.commit(mutationName, payload);
      }
    };
  }

  return functions;
};
